/**
 * Parses a free-text money amount (e.g. "£1,250", "10.99") into integer pence.
 *
 * Strips the currency symbol, thousands separators and whitespace, then requires a
 * finite, positive number. Returns null for anything invalid (empty, "50 pounds", "-1").
 *
 * Uses Number (not parseFloat) so trailing junk is rejected rather than silently
 * truncated — parseFloat("1,250") is 1, which would record a £1,250 gift as £1.00.
 */
export function parseAmountToPence(input: string): number | null {
  const amountInPounds = Number(input.replace(/[£,\s]/g, ''))
  if (!Number.isFinite(amountInPounds) || amountInPounds <= 0) {
    return null
  }
  return Math.round(amountInPounds * 100)
}

/** Turns stored pence back into a donor-facing amount field value. */
export function penceToAmountInput(pence: number): string {
  const pounds = pence / 100
  return Number.isInteger(pounds) ? String(pounds) : pounds.toFixed(2)
}
